<template lang="pug">
#admin_container.container-small
  #container_title
    h1 접속자집계(GA)
  .container_wr
    .local_ov01.local_ov
      p.bold.subt 기간별검색
      date-picker.start_picker(v-model="args.date" range type='date' value-type="format" format="YYYY-MM-DD" placeholder="Start date")
      a.search_btn(@click='getData(title)') 검색
    .ov-top
      .local_ov01.local_cate
        a(@click='getData("visitor")') 접속자
        a(@click='getData("web")') 브라우저
        a(@click='getData("os")') 운영체제
        a(@click='getData("hour")') 시간
        a(@click='getData("weekTable")') 요일
        a(@click='getData("day")') 일
        a(@click='getData("month")') 월
        a(@click='getData("year")') 년
      a.search_btn(href="https://analytics.google.com" target='_blank') 상세보기
    
    .tbl_head00.tbl_wrap
      table
        thead
          tr
            th(v-for="(tit, id) in tableHead[title]" :key="id") {{tit}}
        tbody
          tr(v-if="spinner")
            td.empty_table(colspan='5')
              font-awesome-icon.fas.fa-spin.fa-lg(icon="circle-notch")
          //- 접속자
          tr(v-for="(i, idx) in res" :key="i.idx" v-if="title == 'visitor' && res.length !== 0" :class='[idx % 2 == 1 ? "bg1" : "bg0"]')
            td {{i.ip}}
            td {{i.browser}}
            td {{i.os}}
            td {{i.device}}
            td {{$moment(i.date.replace(/^(.{8})/, '$1 ')).format('YYYY-MM-DD HH:**')}}
          //- 브라우저, 운영체제
          tr(v-for="(i, idx) in res" :key="i.idx" v-if="['web', 'os'].includes(title) && getKeys" :class='[idx % 2 == 1 ? "bg1" : "bg0"]')
            td {{idx+1}}
            td {{i.name}}
            td
              .visit_bar
                span(:style='{width: String(getAverage[idx]) + "%"}')
            td {{i.amount}}
            td {{getAverage[idx]}}
          //- 시간, 요일, 일, 월, 년
          tr(v-for="(i, idx) in res" :key="i.idx" v-if="['hour', 'weekTable', 'day', 'month', 'year'].includes(title) && getKeys" :class='[idx % 2 == 1 ? "bg1" : "bg0"]')
            td {{i.name}}
            td
              .visit_bar
                span(:style='{width: String(getAverage[idx]) + "%"}')
            td {{i.amount}}
            td {{getAverage[idx]}}
          //- 합계
          tr.sum(v-if="['web', 'os'].includes(title) && getKeys")
            td(colspan='3') 합계
            td {{getSum}}
            td {{percentageSum.toFixed(1)+'%'}}
          tr.sum(v-if="['hour', 'weekTable', 'day', 'month', 'year'].includes(title) && getKeys")
            td(colspan='2') 합계
            td {{getSum}}
            td {{percentageSum.toFixed(1)+'%'}}
          tr(v-if="res.length == 0 && !spinner")
            td.empty_table(colspan='5') 자료가 한 건도 없습니다.
    nav.pg_wrap(v-if="title == 'visitor'")
      span.pg
        a.pg_page.pg_start(@click='selectPage("prev")' v-if="paging[2]")
        a.pg_page(v-for="(num, id) in pageNumber" :key="id" @click='selectPage(num)' :class='[page == num ? "pg_current" : ""]') {{num}}
        a.pg_page.pg_end(@click='selectPage("next")' v-if="paging[3]")
    
    div(style="clear: both;")
    hr(style="margin: 30px 0;")
    
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
export default {
  components: {
    DatePicker,
  },
  data() {
    return {
      title: 'visitor',
      tableHead: {
        visitor: ['IP', '브라우저', 'OS', '접속기기', '일시'],
        web: ['순위', '브라우저', '그래프', '접속자수', '비율(%)'],
        os: ['순위', 'OS', '그래프', '접속자수', '비율(%)'],
        hour: ['시간', '그래프', '접속자수', '비율(%)'],
        weekTable: ['요일', '그래프', '접속자수', '비율(%)'],
        day: ['년-월-일', '그래프', '접속자수', '비율(%)'],
        month: ['년-월', '그래프', '접속자수', '비율(%)'],
        year: ['연도', '그래프', '접속자수', '비율(%)'],
      },
      args: {
        nation: 'kr',
        date: [],
      },
      res: [],
      paging: [],
      average: [],
      sum: 0,
      page: 1,
      percentageSum: 0,
      checked: [],
      flagData: {
        editFlag: false,
        descList: true,
      },
      spinner: false,
    };
  },
  computed: {
    pageNumber() {
      if (this.res.length !== 0) {
        let res = new Array(this.paging[1] + 1 - this.paging[0])
          .fill(this.paging[0])
          .map((n, i) => n + i);
        return res;
      }
      return;
    },
    getKeys() {
      if (this.res.length !== 0) {
        let res = [];
        this.res.forEach(e => {
          this.sum += parseFloat(e[Object.keys(e)[0]]);
          res.push(Object.keys(e)[0]);
        });
        return res;
      }
      return;
    },
    getSum() {
      let sum = 0;
      this.res.forEach(e => {
        sum += e.amount;
      });
      return sum;
    },
    getAverage() {
      let res = [];
      this.percentageSum = 0;
      this.res.forEach(e => {
        if (this.getSum == 0) {
          res.push(0);
        } else {
          let percentage = ((parseFloat(e.amount) / this.getSum) * 100).toFixed(
            1,
          );
          res.push(percentage);
          this.percentageSum += parseFloat(percentage);
        }
      });
      return res;
    },
  },
  methods: {
    async getData(title) {
      this.res = [];
      this.spinner = true;
      if (title) {
        this.title = title;
      }
      let args = {
        category: this.title,
        startDate: this.args.date[0],
        endDate: this.args.date[1],
      };
      if (this.title == 'visitor') {
        args.page = this.page;
      }
      await this.$_admin_get('admin/ga', args).then(res => {
        if (res.data.res) {
          this.res = res.data.res;
        }
        if (this.title == 'day') {
          this.res.forEach((e, i) => {
            let format = this.$moment(e.name).format('YYYY-MM-DD');
            this.res[i].name = format;
          });
        } else if (this.title == 'month') {
          this.res.forEach((e, i) => {
            let format = this.$moment(e.name).format('YYYY-MM');
            this.res[i].name = format;
          });
        } else if (this.title == 'visitor' && res.data.res.length > 1) {
          this.res = res.data.res[0];
          this.paging = res.data.res[1];
        }
        this.spinner = false;
      });
    },
    selectPage(num) {
      if (num == 'prev') {
        this.page = this.paging[0] - 1;
      } else if (num == 'next') {
        this.page = this.paging[1] + 1;
      } else {
        this.page = num;
      }
      this.getData(this.title);
    },
  },
  mounted() {
    this.getData();
  },
  created() {
    this.args.date[0] = this.$moment().format('YYYY-MM-DD');
    this.args.date[1] = this.$moment().format('YYYY-MM-DD');
  },
};
</script>

<style scoped>
@import '../../../assets/css/admin.css';
.ov-top {
  width: 100%;
  justify-content: space-between;
  display: flex;
  align-items: center;
}
.ov-top a.search_btn {
  width: 65px;
}
.local_cate a {
  font-weight: bold;
  /* margin: 0 1px; */
  display: inline-block;
  padding: 5px 12px;
  border: 1px solid #c8ced1;
  background: #d6dde1;
  text-decoration: none;
}
.container_wr .local_ov01 {
  display: flex;
}
.local_ov01 p {
  line-height: 34px;
}
.start_picker,
.end_picker {
  width: 220px;
  margin: 0 10px;
}
.search_btn {
  line-height: 34px;
  text-align: center;
  color: white;
  width: 50px;
  border: 0;
  background-color: #6f809a;
  border-radius: 7px;
}
.search_btn:hover {
  background-color: #545f70;
}
.subt {
  margin-right: 7px;
}
.tbl_head00 tbody .bg0 {
  background: #fff !important;
}
.tbl_head00 tbody .bg1 {
  background: #eff3f9 !important;
}
tbody tr.sum {
  background: #eee;
}
</style>
